import {Components} from 'components/components';

class DuplicateIdNavigationItem {
  get id() { return 'show-duplicate-ids'; }
  get element() { return document.getElementById(this.id); }
  get showing() { return this.element !== null; }
  
  update(duplicateIdFinder) {
    if (duplicateIdFinder.length) {
      let textEl = (this.element || this.makeElement).querySelector('.text');
      textEl.innerText = duplicateIdFinder.length === 1 ? `1 DUPE` : `${duplicateIdFinder.length} DUPES`;
    } else {
      this.remove();
    }
  }
  
  get makeElement() {
    let link = Components.tag('a',
      {id: this.id, class: 'btn-danger iconic-link', href: '#duplicate-ids', 'data-toggle': 'modal'},
      Components.iconic('bomb'),
      Components.tag('span', {class: 'text'}, `DUPES`),
    );
    
    document.getElementById('navigation').append(Components.tag('li', link));
    return link;
  }
  
  remove() {
    this.element?.parentElement?.remove();
  }
}

class DuplicateIdNotifier {
  get finder() { return this._finder || (this._finder = new DuplicateIdFinder()); }
  
  get navItem() { return new DuplicateIdNavigationItem(); }
  
  notify(action=DuplicateIdNotifier.settings.get('action')) {
    if (action === 'ignore') { return; }
    
    this.log();
    
    let modal = this.updateModal();
    if (action === 'popup') { modal.show() }
  }
  
  log() {
    let logEach = DuplicateIdNotifier.settings.get('logEachDuplicate');
    if (this.finder.length === 0) { return }
    
    console.groupCollapsed(`Found ${this.finder.length} duplicated IDs`);
    
    this.finder.forEach((id, els) => {
      console.groupCollapsed(`${els.length} elements have ID ${id}`);
      if (logEach) {els.forEach(el => console.log(Sherlock.stringPath(el), el))}
      console.groupEnd();
    })
    
    console.groupEnd();
  }
  
  updateModal() {
    this.navItem.update(this.finder);
    
    return new Components.Modal({
      id: 'duplicate-ids',
      class: 'duplicate-id-modal',
      title: (title) => {
        title.append('Duplicate IDs in DOM'); 
        title.append(Components.tag("small",
          {class: 'duplicate-id-modal--actions'},
          "When I find duplicates, I will ",
          this.actionLink('popup', 'popup'),
          ' | ',
          this.actionLink('detect', 'detect but ignore'),
          ' | ',
          this.actionLink('ignore', 'ignore it entirely'),
          '.'));
      },
      body: (body) => {
        body.append(Components.tag('p', `This page has `, Components.tag('strong', this.finder.length), ` duplicated ID${this.finder.length === 1 ? '' : 's'}.
          These will cause issues with JavaScript, especially if one of them is a modal, tooltip, or picker.
          The following IDs are duplicated:`));
        var list = $('<div>').appendTo(body);
        body.append(Components.tag('p', `It is likely that the IDs are auto-generated based on user content (document names, applicant names, etc) or models (`, Components.tag('code', 'user_2'), ', ', Components.tag('code', 'recruitment_name'), `). You should find some way to de-duplicate them.`));
        DuplicateIdNotifier.highlightCurrentAction();
        
        this.finder.duplicatedIds.forEach((id) => {
          list.append(this._summaryForId(id));
        });
      },
      buttons: Components.Modal.okButton('Highlight All', {class: 'btn-primary'}, (btn) => {
        btn.addEventListener('click', () => this.highlightAll());
      })
    }).fill();
  }
  
  actionLink(action, displayName) {
    return Components.tag("a",
      {href: '#', 'data-duplicate-id-action': action},
      (l => l.addEventListener('click', DuplicateIdNotifier.updateAction)),
      displayName);
  }
  
  _summaryForId(id) {
    var codeBlocks = Components.tag('ul');
    this.finder.duplicatesById[id].forEach(el => {
      codeBlocks.append(Components.tag('li',
        Components.tag('span', {class: 'metadata'}, Sherlock.pathTo(el)),
        Components.tag('br'),
        Components.tag('code', Sherlock.fingerprint(el))
      ));
    });
    
    return Components.tag("div", {class: 'duplicate-id-modal--id-summary'},
      Components.tag('h4', id, ' ', Components.iconic('search', icon => icon.addEventListener('click', (e) => this.highlightId(id)))),
      codeBlocks);
  }
  
  highlightAll(ids=this.finder.duplicatedIds) {
    ids.forEach(id => this.highlightId(id));
  }
  
  highlightId(id) {
    this.finder.duplicatesById[id].forEach(el => {
      var highlight = el;
      while(getComputedStyle(highlight).display !== 'block') { highlight = highlight.parentElement }
      highlight.classList.add(highlight === el ? "duplicate-id-highlight" : "duplicate-id-within-highlight")
    });
  }
  
  static updateAction(event) {
    event.preventDefault();
    DuplicateIdNotifier.settings.set('action', event.target.dataset.duplicateIdAction);
    DuplicateIdNotifier.highlightCurrentAction();
  }
  
  static highlightCurrentAction() {
    var action = DuplicateIdNotifier.settings.get('action');
    document.querySelectorAll('[data-duplicate-id-action]').forEach(link => {
      link.classList.toggle('duplicate-id-modal--current-action', link.dataset.duplicateIdAction === action);
    });
  }
  
  static settings = new ParamStore('duplicateid', () => { return {
    action: document.body.parentElement.classList.contains('development-area') ? 'detect' : 'ignore',
    logEachDuplicate: !document.body.parentElement.classList.contains('test-area'),
    logTotal: true,
  }});
}

window.addEventListener("DOMContentLoaded", () => {
  new BusyBody({
    selector: '*[id]',
    startVisits: (bb) => {bb.needsCheck = false},
    added: (m, bb) => bb.needsCheck = true,
    removed: (m, bb) => bb.needsCheck = true,
    finishVisits: (bb) => {
      if (bb.needsCheck) {
        new DuplicateIdNotifier().notify();
      }
    },
  })
});
